module.exports = {"TXTACL_Close":{"id":"TXTACL_Close","defaultMessage":"Bezárás","flags":["TRACK"],"track":"Close"}}